<template>
    <v-app id="app">
        <v-content transition="slide-x-transition">
            <router-view></router-view>
        </v-content>
        <component-loader :is-loading="isLoading" ></component-loader>

    </v-app>
</template>

<script>
import ComponentLoader from './components/componentLoader/ComponentLoader'

export default {
  components: {
    ComponentLoader
  },
  data () {
    return {
        isLoading: false
    }
  },
  methods: {
    
    handler ({isLoading}) {
      this.isLoading = isLoading
    },
  },
   created () {
    //this.setLoadingCtrlFunction(this.controlLoadingSpinner)
  },
  mounted () {
    this.$root.$on('isLoading', this.handler)
  }
}
</script>

<style></style>
